module.exports = __webpack_public_path__ + "assets/9eb669b2c246a4d8fd74e780b48220bd.mp4";